<template>
    <div>
        <a-row>
            <a-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 20, offset: 2 }">
                <a-row :gutter="[16, 16]">
                    <a-col class="mb-20 text-center" :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 8 }"
                        :lg="{ span: 10 }">
                        <MobileFrameVue title="Login" name="bg-login" />
                    </a-col>
                    <a-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 16 }" :lg="{ span: 14 }">
                        <div>
                            <a-list class="mb-20" item-layout="horizontal">
                                <a-list-item>
                                    <a-list-item-meta>
                                        <div slot="title">
                                            <h3 class="mt-10 mb-10" style="color: #610C9F !important">
                                                IC-APP
                                            </h3>
                                            
                                            <span v-if="!loadRole">
                                                <span v-if="Object.keys(objectDataRole).length !== 0">
                                                    <span
                                                        v-if="objectDataRole.permissions.includes(`ic-pay`) || objectDataRole.permissions.includes(`ic-app`)"
                                                        style="font-size: 14px; color: #7d7c7c" class="font-web">
                                                        <a-icon class="mr-5" style="font-weight: 900; color: #1aacac"
                                                            type="safety-certificate" theme="filled" />MUIC Account
                                                        ของท่านสามารถ <i
                                                            style="font-weight: 900; color: #1aacac">ใช้งานได้</i>
                                                    </span>
                                                    <span v-else style="font-size: 14px; color: #7d7c7c" class="font-web">
                                                        <a-icon class="mr-5" style="font-weight: 900; color: #C70039"
                                                            type="warning" theme="filled" />MUIC Account ของท่าน <i
                                                            style="font-weight: 900; color: #C70039">ไม่สามารถใช้งานได้</i>
                                                    </span>
                                                </span>
                                                <span v-else>
                                                    <span style="font-size: 14px; color: #7d7c7c" class="font-web">
                                                        <a-icon class="mr-5" style="font-weight: 900; color: #C70039"
                                                            type="warning" theme="filled" />MUIC Account ของท่าน <i
                                                            style="font-weight: 900; color: #C70039">ไม่สามารถใช้งานได้</i>
                                                    </span>
                                                </span>
                                            </span>

                                            <br />
                                        </div>

                                        <div slot="description"></div>
                                        <a-avatar slot="avatar" shape="square" :size="70"
                                            src="imageApp/MUIC_APP_512_02.png" />
                                    </a-list-item-meta>
                                </a-list-item>
                            </a-list>
                            <span style="font-size: 14px" class="mt-30">
                                
                                <!-- The benefits process on IC-APP will be brand new. This tutorial
                                will guide you through IC-APP and prepare you for the upcoming
                                in new budget year -->
                            </span>
                            <!-- Download -->
                            <div class="mt-0">
                                <secDownload />
                            </div>
                        </div>
                    </a-col>
                </a-row>
            </a-col>
        </a-row>

        <a-row class="mt-50 mb-50">
            <a-col :span="21" :offset="1">
                <div>
                    
                    <a-tabs size="large" default-active-key="1"
                        :tab-position="Number.parseInt(window.width) <= 800 ? `top` : `left`">
                        <a-tab-pane key="3">
                            <span slot="tab">
                                <p class="font-web m-0 font-cud">
                                    <a-icon type="lock" class="mr-5" />การเข้าใช้งาน
                                    และตั้งค่าความปลอดภัย
                                </p>
                            </span>
                            <secAuth />
                        </a-tab-pane>
                        <a-tab-pane key="2">
                            <span slot="tab">
                                <p class="font-web m-0 font-cud">
                                    <a-icon type="safety" class="mr-5" />ข้อกำหนด
                                    และนโยบายความเป็นส่วนตัว
                                </p>
                            </span>
                            <secTermCondition />
                        </a-tab-pane>
                        <a-tab-pane key="1">
                            <span slot="tab">
                                <p class="font-web m-0 font-cud">
                                    <a-icon type="appstore" class="mr-5" /><strong>Overview</strong>
                                </p>
                            </span>
                            <secOverview />
                        </a-tab-pane>
                        <a-tab-pane key="4">
                            <span slot="tab">
                                <p class="font-web m-0 font-cud">
                                    <a-icon type="wallet" class="mr-5" />การใช้งาน
                                    <strong>IC Meal</strong>
                                </p>
                            </span>
                            <secPay :listData="listDataShop" />
                        </a-tab-pane>
                        
                        
                    </a-tabs>
                </div>
            </a-col>
        </a-row>
    </div>
</template>

<script>
import MobileFrameVue from "./MobileFrame.vue";
import secDownload from "./sectionContent/secDownload.vue";
import secAuth from "./sectionContent/secAuth.vue";
import secTermCondition from "./sectionContent/secTermCondition.vue";
import secOverview from "./sectionContent/secOverview.vue";
import secPay from "./sectionContent/secPay.vue";
import secIssue from './sectionContent/secIssue.vue';
import secFaq from "./sectionContent/secFaq.vue";

export default {
    components: {
        MobileFrameVue,
        secDownload,
        secOverview,
        secPay,
        secAuth,
        secTermCondition,
        secIssue,
        secFaq
    },
    data() {
        return {
            text: `A dog is a type of domesticated animal.Known for its loyalty and faithfulness,it can be found as a welcome guest in many households across the world.`,
            activeKey: ["1"],
            window: {
                width: 0,
                height: 0,
            },
            objectDataRole: {},
            loadRole: false,
            listDataShop: [],
            dataFaq: [],
        };
    },
    created() {
        globalThis.addEventListener("resize", this.handleResize);
        this.handleResize();
    },
    destroyed() {
        globalThis.removeEventListener("resize", this.handleResize);
    },
    mounted() {
        this.getRoleApp()
        this.getSponserStore()
        this.getFAQlist()
    },
    methods: {
        handleResize() {
            this.window.width = globalThis.innerWidth;
            this.window.height = globalThis.innerHeight;
        },
        async getRoleApp() {
            this.loadRole = true
            this.objectDataRole = {}
            try {
                const res = await this.$http.get(`/whoami-apps/`);
                if (res.status === 200) {
                    console.log(res.data)
                    this.objectDataRole = res.data
                    this.loadRole = false
                } else {
                    const error = new Error('Request Failed');
                    error.res = res;
                    error.response = res;
                    throw error;
                }
            } catch (error) {
                this.loadRole = false
                this.$notification.open({
                    style: {
                        backgroundColor: "#ff1919",
                        color: "#ffffff",
                    },
                    message: function (h) {
                        return h("div", [
                            h("strong", { class: "" }, `Error ${error.response.status}`),
                        ]);
                    },
                    description: `Problem issue connect api : /whoami-apps/`,
                });
            }
        },
        async getSponserStore() {
            this.listDataShop = []
            try {
                const res = await this.$http.get(`/muic-pay/store/list-view/`);
                if (res.status === 200) {
                    this.listDataShop = res.data
                } else {
                    const error = new Error('Request Failed');
                    error.res = res;
                    throw error;
                }
            } catch (error) {
                this.listDataShop = []
            }
        },
        async getFAQlist() {
            this.dataFaq = [];
            try {
                const res = await this.$http.get(`/faq/?topic=4`);
                if (res.status === 200) {
                    this.dataFaq = res.data.map((item) => ({ ...item }));
                    this.dataFaq.sort((a, b) => {
                        return b.view_order - a.view_order;
                    });
                } else {
                    const error = new Error('Request Failed');
                    error.res = res;
                    error.response = res;
                    throw error;
                }
            } catch (error) {
                this.dataFaq = [];
            }
        },

    },
};
</script>

<style scoped>
.font-cud {
    font-weight: 700 !important;
    font-size: 16px;
}
</style>